import type { LeadsBySourceItem } from "api/crm-analytics";
import { SourceBarChartCard } from "./SourceBarChartCard";

export const ApprovalsBySourceCard = ({
  data,
  isLoading,
  dateLabel
}: {
  data: LeadsBySourceItem[] | undefined;
  isLoading: boolean;
  dateLabel: string;
}) => (
  <SourceBarChartCard
    title="Approvals by source"
    subtitle={`Application approvals by source – ${dateLabel}`}
    data={data}
    isLoading={isLoading}
  />
);
